// import { useAuth } from "react-oidc-context";
import axios from "axios";

const axiosInstance = axios.create({
  baseURL: `${import.meta.env.VITE_API_URL}`,
  timeout: 60000,
});

axiosInstance.interceptors.request.use(
  async (config) => {
    // try {
    // const auth = useAuth();
    // if (auth.isAuthenticated) {
    //   config.headers.Authorization = `Bearer ${auth.user?.access_token}`;
    // }
    // } catch (e) {
    //   console.error(e);
    //   console.error("error setting token ");
    // }

    config.maxBodyLength = Infinity;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
